import { ReactNode } from 'react';

interface FieldProps {
  label: string;
  htmlFor?: string;
  children: ReactNode;
}

export function Field({ label, htmlFor, children }: FieldProps) {
  return (
    <div>
      {htmlFor ? (
        <label htmlFor={htmlFor} className="block text-sm font-medium text-text-medium mb-1">
          {label}
        </label>
      ) : (
        <p className="text-sm font-medium text-text-medium mb-1">{label}</p>
      )}
      <div className="text-sm text-text-dark">{children}</div>
    </div>
  );
}
